<template>
  <transition name="el-zoom-in-top">
    <el-card class="box-card" style="text-align: left;" v-show="add.addshow">
      <div slot="header" class="clearfix">
        <el-row>
          <el-col :span="12">
            <h3>奖品充值</h3>
          </el-col>
          <el-col :span="12">
            <el-button style="float: right;" type="primary" @click="add.addshow=false">收起</el-button>
          </el-col>
        </el-row>
      </div>
      <div v-show="show">
        <!-- 填写基础信息 -->
        <el-form
          ref="awardform"
          :model="awardform"
          label-width="140px"
          style="width:50%"
          :rules="rules"
        >
          <el-form-item
            :label="awardvaluelabel"
            prop="awardInfuseValue"
            :rules="[
      { required: true, message: '该字段不能为空'},
      { type: 'number', message: '必须为数字值'}
    ]"
          >
            <el-input v-model.number="awardform.awardInfuseValue" style="width:50%">
              <template slot="append">{{awardvalueunit}}</template>
            </el-input>
          </el-form-item>
          <el-form-item label="单据号" prop="receiptId">
            <el-input v-model.trim="awardform.receiptId" style="width:50%"></el-input>
          </el-form-item>
          <el-form-item label="奖品类型" prop="awardStuffType">
            <el-select v-model="awardform.awardStuffType" placeholder="请选择奖励类型" style="width:50%" @change="getpoollist(awardform.awardStuffType)">
              <el-option
                v-for="item in awardStuffTypelist"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充值奖品" prop="awardStuffUuid">
            <el-select
              v-model="awardform.awardStuffUuid"
              placeholder="请选择充值奖品"
              style="width:50%"
            >
              <el-option
                v-for="item in awardStuffPoollist"
                :key="item.awardStuffUuid"
                :label="item.awardStuffName"
                :value="item.awardStuffUuid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传图片" prop="receiptId">
            <el-upload
              ref="upload"
              :action="uploadurl"
              :data="uploaddata"
              list-type="picture-card"
              :on-success="qinchulist"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :auto-upload="false"
              :file-list="fileList"
              :limit="1"
              :on-change="onchange"
              name="uploadFile"
            >
              <el-tooltip class="item" effect="dark" content="只能上传一张图片" placement="top">
                <i class="el-icon-plus"></i>
              </el-tooltip>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="图片展开" />
            </el-dialog>
          </el-form-item>
          <el-form-item></el-form-item>
        </el-form>
        <div style="text-align: center;">
          <el-button style="margin-top: 12px;" @click="resetForm('awardform')">重置</el-button>
          <el-button style="margin-top: 12px;" @click="submitadd('awardform')" type="primary">提交</el-button>
        </div>
      </div>
    </el-card>
  </transition>
</template>

<script>
import {
  logawardstuffinfuseadd,
} from "@/api/market/pond";
import { findlistbytypeandgroup} from "@/api/market/marketing";
export default {
  props: {
    search: {
      type: Function,
      default: null
    },
    add: {
      type: Object,
      default: () => {
        return {
          addshow: "",
          avatar: "",
          roles: ""
        };
      }
    }
  },
  data() {
    return {
      //基础数据
      awardvaluelabel:'充值金额',
      awardvalueunit:'元',
      awardStuffPoollist: [],
      awardStuffTypelist: [
        {
          value: 0,
          label: "红包"
        },
        {
          value: 1,
          label: "积分"
        },
        {
          value: 2,
          label: "实物"
        },
        {
          value: 3,
          label: "优惠卷"
        }
      ],
      show: true,
      active: 1,
      awardform: {
        awardStuffUuid: null,
        receiptImageUrl: "",
        awardStuffType: null,
        infuseState: 0,
        receiptId: null,
        awardInfuseValue: null
      },
      // 上传图片
      uploaddata: { folder: "Hirisw" },
      uploadurl:
        process.env.VUE_APP_BASE_API +
        "/mtscitech/back/fileuploader/fileupload",
      ifFile: false,
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      rules: {
        awardStuffType: [
          { required: true, message: "请选择奖励类型", trigger: "blur" }
        ],
        awardStuffUuid: [
          { required: true, message: "请选择奖品", trigger: "blur" }
        ],
        receiptId: [{ required: true, message: "请选择票据", trigger: "blur" }]
      }
    };
  },
  mounted() {
  },
  methods: {
    // 获取奖品池列表
    getpoollist(awardType){
      switch (awardType) {
        case 0:this.awardvaluelabel='充值金额';this.awardvalueunit = "元";
          break;
       case 1:this.awardvaluelabel='充值积分';this.awardvalueunit = "个";
          break;
           case 2:this.awardvaluelabel='充值数量';this.awardvalueunit = "个";
          break;
           case 3:this.awardvaluelabel='充值数量';this.awardvalueunit = "个";
          break;
        default:
          break;
      }
      this.awardform.awardStuffUuid = '';
      findlistbytypeandgroup({ page: 1, rows: 200 ,awardType:awardType}).then(response => {
      this.awardStuffPoollist = response.data.rows;
    });
    },
    //保存提交
    submitadd(formName) {
      this.$refs[formName].validate(valid => {
        //基础表单验证
        if (valid) {
          // 上传图片
          if (this.ifFile) {
            this.uploadurl =
              process.env.VUE_APP_BASE_API +
              "/mtscitech/back/fileuploader/fileupload";
            this.$refs.upload.submit();
          } else {
            logawardstuffinfuseadd(this.awardform).then(response => {
              if (response.status_code == 200) {
                this.$message({
                  type: "success",
                  message: "注入成功!"
                });
                this.resetForm("awardform");
                this.search();
              } else {
                this.$message({
                  type: "warning",
                  message: "注入失败!请检查字段"
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs.upload.clearFiles();
    },
    //文件上传
    submitUpload() {},
    // upload
    handleRemove(file, fileList) {
      this.ifFile = false;
      console.log(this.update.ifFile);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onchange(file) {
      this.ifFile = !this.ifFile;
    },
    qinchulist(response, file, fileList) {
      //  图片上传成功后获取图片地址再提交
      //  this.$refs.upload.clearFiles();
      this.awardform.receiptImageUrl = response.data;
      logawardstuffinfuseadd(this.awardform).then(response => {
        if (response.status_code == 200) {
          this.$message({
            type: "success",
            message: "添加成功!"
          });
          this.resetForm("awardform");
          this.search();
        } else {
          this.$message({
            type: "warning",
            message: "添加失败!请检查字段"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
